import UserLayout from '../../layouts/NewUserLayout.vue'

export default {
  sort: 1,
  path: '/newUser',
  name: 'newUser',
  component: UserLayout,
  children: [
    {
      path: '',
      redirect: 'orders'
    },
    {
      path: 'orders',
      name: 'new-user-orders',
      component: () => import('@/views/User/newOrder.vue'),
    },
    {
      path: 'order',
      name: 'user-order',
      component: () => import('@/views/User/orders')
    },
    // 会员
    {
      path: 'member',
      name: 'new-member',
      component: () => import('@/views/User/newConsumption-records.vue')
    },
    // 账户授权
    {
      path: 'account-auth',
      name: 'account-auth',
      component: () => import('@/views/User/newAccountManagement/index.vue')
    },
    // 积分商城
    {
      path: 'my-points',
      name: 'new-points-mall',
      component: () => import('@/views/User/newPointsMall.vue')
    },
    {
      path: 'consulting-service',
      name: 'user-consulting-service',
      component: () => import('@/views/User/consulting-service/index'),
      redirect: '/user/consulting-service/form',
      children: [
        {
          name: 'consulting-service-records',
          path: 'records',
          meta: {
            title: '咨询记录'
          },
          component: () => import('@/views/User/consulting-service/records')
        },
        {
          name: 'consulting-service-form',
          path: 'form',
          meta: {
            title: '我要咨询'
          },
          component: () => import('@/views/User/consulting-service/form')
        }
      ]
    },
    {
      path: 'system-message',
      name: 'user-system-message',
      component: () => import('@/views/User/system-message')
    },
    //申请邮寄
    {
      path: 'system-courier',
      name: 'user-system-courier',
      component: () => import('@/views/User/newCourier/index')
    },
    //提交凭证
    {
      path: '/payment',
      name: 'payment',
      component: () => import('@/views/User/components/PaymentMethodDialog.vue'),
    },
    // 最终费用
    {
      path: '/costInfo/newCostCheck',
      name: 'new-cost-check',
      component: () => import('@/views/User/components/NewCostCheck.vue')
    },
    // 预估费用
    {
      path: '/costInfo/newCostEstimate',
      name: 'new-cost-estimate',
      component: () => import('@/views/User/components/NewCostEstimate.vue')
    },
    // 下载链接
    {
      path: '/downLink',
      name: 'downLink',
      component: () => import('@/views/User/components/downLink.vue')
    },
    // 在线浏览测试数据
    {
      path: '/onlineTestData',
      name: 'onlineTestData',
      component: () => import('@/views/User/components/onlineTestData.vue')
    },
    // 回收样品
    {
      path: '/recycleSample',
      name: 'recycleSample',
      component: () => import('@/views/User/components/recycleSample.vue'),
    },

    {
      path: 'courier-record',
      name: 'courier-record',
      component: () => import('@/views/User/newCourier/courier-record')
    },
    //回收记录
    {
      path: 'recycle-record',
      name: 'recycle-record',
      component: () => import('@/views/User/newRecycleRecord/recycleRecord')
    },
    {
      path: 'appraise-new',
      name: 'appraise-new',
      component: () => import('@/views/User/appraise-new/index.vue')
    },
    {
      path: 'template',
      name: 'user-template',
      component: () => import('@/views/User/template/index')
    },
    {
      path: 'express',
      name: 'user-express',
      component: () => import('@/views/User/express')
    },
    {
      path: 'recommend',
      name: 'user-recommend',
      component: () => import('@/views/User/recommend')
    },
    {
      path: 'submission',
      name: 'user-submission',
      component: () => import('@/views/User/submission')
    },
    {
      path: 'receivingAddress',
      name: 'user-receivingAddress',
      component: () => import('@/views/User/receivingAddress')
    },
    //委托信息
    {
      path: 'entrustInfo',
      name: 'entrust-info',
      component: () => import('@/views/new/entrustInfo/entrustInfo.vue')
    },
    //个人信息
    {
      path: 'personalInfo',
      name: 'personal-info',
      component: () => import('@/views/new/personalInfo/personalInfo.vue')
    },
    {
      path: 'discountCoupon',
      name: 'user-discountCoupon',
      component: () => import('@/views/User/discountCouponList')
    },
    {
      path: 'thankReward',
      name: 'thankReward',
      component: () => import('@/views/User/thankReward')
    },
    {
      path: 'appraise',
      name: 'appraise',
      component: () => import('@/views/User/appraise/index')
    },
    {
      path: 'Im',
      name: 'user-Im',
      component: () => import('@/views/User/Im')
    },
    {
      path: 'user',
      component: () => import('@/views/User/User')
    },
    { name:"personal-center",
      path: 'personalCenter',
      component: () => import('@/views/User/personalCenter.vue')
    },
    //优惠券
    {
     path: 'myCoupon',
     name: 'my-coupon',
     component: () => import('@/views/User/couponList/couponList.vue'),
    }

]
}



// WEBPACK FOOTER //
// ./src/router/modules/newUser.js